import { BrandBrandLightDerivWordmarkHorizontal25YearsEnglishIcon } from '@deriv/quill-icons';

import './redirection-page.scss';

const RedirectionPage = () => (
    <div className='redirection_page'>
        <div className='redirection_page__logo' data-testid='dt_redirection_page_logo'>
            <BrandBrandLightDerivWordmarkHorizontal25YearsEnglishIcon height='120px' width='120px' />
        </div>
    </div>
);

export default RedirectionPage;
